import productSearchResults from './productSearchResults';

export default productSearchResults;
